import { render, staticRenderFns } from "./MarketLanding.vue?vue&type=template&id=2a063f58&scoped=true&"
import script from "./MarketLanding.vue?vue&type=script&lang=js&"
export * from "./MarketLanding.vue?vue&type=script&lang=js&"
import style0 from "./MarketLanding.vue?vue&type=style&index=0&id=2a063f58&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a063f58",
  null
  
)

export default component.exports